import { Component } from '@angular/core';


@Component({
  selector: 'mui-list-item-action',
  template: `
    <ng-content></ng-content>`,
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.mui-list-item__action]': 'true'
    /* eslint-enable @typescript-eslint/naming-convention */
  }
})
export class MuiListItemAction {
}
